import React, { useEffect, useMemo, useState } from 'react'
import { supabase } from '../lib/supabase'
import { clearTariffeCache } from '../lib/dataloader'

export default function AdminEirZone() {
  const [province, setProvince] = useState([])
  const [zone, setZone] = useState({})  // sigla -> zona
  const [edits, setEdits] = useState({})
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => { load() }, [])
  async function load() {
    setLoading(true)
    const [p, z] = await Promise.all([
      supabase.from('province').select('*').order('nome'),
      supabase.from('eir_zone_province').select('*'),
    ])
    setProvince(p.data || [])
    const map = {}
    for (const r of (z.data || [])) map[r.sigla] = r.zona
    setZone(map)
    setLoading(false)
  }

  async function saveAll() {
    setSaving(true)
    const rows = Object.entries(edits).map(([sigla, zona]) => ({ sigla, zona: parseInt(zona) }))
    if (rows.length) await supabase.from('eir_zone_province').upsert(rows)
    clearTariffeCache()
    setEdits({})
    await load()
    setSaving(false)
  }

  const filtered = useMemo(() => {
    const f = filter.toLowerCase().trim()
    if (!f) return province
    return province.filter(p =>
      p.sigla.toLowerCase().includes(f) ||
      p.nome.toLowerCase().includes(f) ||
      (p.regione || '').toLowerCase().includes(f))
  }, [province, filter])

  if (loading) return <div className="loading">Caricamento...</div>

  return (
    <div>
      <div className="page-header flex-between">
        <div>
          <h1>Zone territoriali EIR</h1>
          <p>Mapping provincia → zona (1..5). Le 5 zone EIR raggruppano le province per profilo rischio.</p>
        </div>
        {Object.keys(edits).length > 0 && <button className="btn btn-primary" onClick={saveAll} disabled={saving}>{saving?'Salvataggio...':`Salva ${Object.keys(edits).length} modifiche`}</button>}
      </div>

      <div className="card">
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <input placeholder="Cerca provincia, sigla o regione..." value={filter} onChange={e => setFilter(e.target.value)} />
        </div>

        <div className="table-wrap">
          <table>
            <thead><tr><th>Sigla</th><th>Provincia</th><th>Regione</th><th>Zona EIR</th></tr></thead>
            <tbody>
              {filtered.map(p => {
                const z = edits[p.sigla] !== undefined ? edits[p.sigla] : zone[p.sigla] || ''
                const dirty = edits[p.sigla] !== undefined
                return (
                  <tr key={p.sigla}>
                    <td><strong>{p.sigla}</strong></td>
                    <td>{p.nome}</td>
                    <td className="text-muted">{p.regione}</td>
                    <td>
                      <select value={z} onChange={e => setEdits(s => ({ ...s, [p.sigla]: e.target.value }))}
                              style={{ width: 110, background: dirty ? '#FFF7E5' : 'transparent' }}>
                        <option value="">—</option>
                        {[1,2,3,4,5].map(n => <option key={n} value={n}>Zona {n}</option>)}
                      </select>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
